///<amd-module name="typeahead/core/message/SuggestionShownMessage" />

import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import {IEssSuggestionResult} from "typeahead/core/Suggestion";

export class SuggestionShownMessage implements TypeaheadMessage {

    public static getTopic(): string {
        return "typeahead.suggestion_shown";
    }

    private domElementId: string;
    private elementValue: string;
    private suggestions: IEssSuggestionResult[];
    private activeESSTests: string;
    private lob: string;
    private renderTime: number;

    constructor(suggestions: IEssSuggestionResult[], elementValue: string, activeESSTests: string, lob: string,
                renderTime: number, domElementId: string) {
        this.suggestions = suggestions;
        this.domElementId = domElementId;
        this.elementValue = elementValue;
        this.lob = lob;
        this.activeESSTests = activeESSTests;
        this.renderTime = renderTime;
    }

    public getTopic(): string {
        return SuggestionShownMessage.getTopic();
    }

    public getDomElementId(): string {
        return this.domElementId;
    }

    public getShownSuggestions(): IEssSuggestionResult[] {
        return this.suggestions;
    }

    public getElementValue(): string {
        return this.elementValue;
    }

    public getLob(): string {
        return this.lob;
    }

    public getActiveESSTests(): string {
        return this.activeESSTests;
    }

    public getRenderTime(): number {
        return this.renderTime;
    }
}
